/**
 * PdfPreview — duenner Wrapper um react-pdf Document/Page.
 *
 * Liegt isoliert vom FilePreviewModal damit der pdfjs-Worker-Import nicht in
 * Code-Pfaden landet, die kein PDF brauchen (Code-Splitting-freundlich).
 */
import { useState } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './pdfWorker';

interface Props {
  url: string;
  page: number;
  /** Wenn das Doc geladen ist, gib Page-Count an den Parent (fuer Navi). */
  onPageCount: (n: number) => void;
}

export function PdfPreview({ url, page, onPageCount }: Props) {
  const [loadError, setLoadError] = useState<string | null>(null);

  if (loadError) {
    return (
      <div className="text-sealwax flex items-center justify-center py-12 text-sm">
        PDF konnte nicht gerendert werden: {loadError}
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <Document
        file={url}
        onLoadSuccess={({ numPages }) => onPageCount(numPages)}
        onLoadError={(e) => setLoadError(e.message)}
        loading={<div className="text-ink-faint py-12 text-sm">Lade PDF…</div>}
        error={<div className="text-sealwax py-12 text-sm">Fehler beim Laden des PDFs.</div>}
      >
        <Page
          pageNumber={page}
          width={Math.min(900, window.innerWidth - 120)}
          renderAnnotationLayer={false}
          renderTextLayer={false}
          className="shadow-lg"
        />
      </Document>
    </div>
  );
}
